import { createContext } from "react";

const DF_CO0010Context = createContext();

export { DF_CO0010Context };
